import React, { useEffect, useRef, useState } from 'react';

import { AccordionData } from '@/services/types/common';

import styles from './styles.module.css';

interface Props {
  data: AccordionData;
  isOpen: boolean;
  btnOnClick: () => void;
}

const AccordionItem: React.FC<Props> = ({ data, isOpen, btnOnClick }) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    const openAccordion = () => {
      const contentEl = contentRef.current as HTMLDivElement;
      setHeight(contentEl.scrollHeight);
    };

    const closeAccordion = () => {
      setHeight(0);
    };

    if (isOpen) {
      openAccordion();
    } else {
      closeAccordion();
    }
  }, [isOpen]);

  return (
    <li className={`${styles.accordionItem} ${isOpen ? styles.accordionItemIconActive : ''}`}>
      <h2 className={styles.accordionItemTitle}>
        <button className={styles.accordionItemBtn} onClick={btnOnClick}>
          <p> {data.title}</p>

          <svg className={styles.accordionItemIcon} width="24" height="24" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="12" style={{ fill: 'var(--totem-color-primary-500)' }} />
            <path d="M8 10l4 4 4-4" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      </h2>
      <div className={styles.accordionItemContainer} style={{ height }}>
        <div ref={contentRef} className={styles.accordionItemContent}>
          {data.content}
        </div>
      </div>
    </li>
  );
};

export default AccordionItem;
